export default __webpack_public_path__ + "static/media/prog_blanc.5e6ff325.svg";